// extracted by mini-css-extract-plugin
export var priceTable = "cennik-module--price-table--vwtyI";